import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import 'react-slidedown/lib/slidedown.css'
import Dropdown from '../../../dropdown'
import config from '../../../../config'

import { AuthGDPR } from '../common/AuthGDPR'
import { AuthResponsable } from '../common/AuthResponsable'
import { AuthEdat17 } from '../common/AuthEdat17'

import { AuthCompromis, AuthCompromisMenors16 } from './AuthCompromis'
import { AuthSortides , AuthSortidesMenors } from './AuthSortides'
import { AuthMobils } from './AuthMobils'
import { AuthAlternanca } from './AuthAlternanca'
import { AuthMedica } from './AuthMedica'
import { AuthDretsImatgeCompostMajors18, AuthDretsImatgeCompostMenors18 } from './AuthDretsImatge'
import { AuthRecursosDigitalsMajors18 , AuthRecursosDigitalsMenors18 } from './AuthRecursosDigitals'

export function EnrolmentFormAuthorizations(props) {

  const [errors, setErrors] = useState({});

  const handleErrors = (nom, error) => {
    //console.log('error', nom, error)
    setErrors(error)
  }

  /* AUTORITZACIONS */
  const [authorizationsOpen, setAuthorizationsOpen] = useState(true);

  const toggleAuthorizationsOpen = () => {
    setAuthorizationsOpen(!authorizationsOpen);
  }

  const [authCompromis, setAuthCompromis ] = useState("0");
  const [authIntranet, setAuthIntranet ] = useState(false);
  const [authRecursosDigitals, setAuthRecursosDigitals ] = useState(false);
  const [authInternet, setAuthInternet ] = useState(false);

  //const [authDretsImatge , setAuthDretsImatge ] = useState("0");

  const [authMobils, setAuthMobils] = useState("0");
  const [authSortides, setAuthSortides ] = useState("0");
  const [authMedica, setAuthMedica ] = useState("0");
  const [authAlternanca, setAuthAlternanca ] = useState("0");

  const [authResponsable, setAuthResponsable ] = useState("0");
  const [authGDPR, setAuthGDPR ] = useState("0");


  const major18 = props.dadesPersonals.edat >= 18 || false
  //const major16 = props.dadesPersonals.edat >= 16 || false
  const nomesCicles = ( props.dadesEstudis.cicle === "CFGM" || props.dadesEstudis.cicle === "CFGS" )

  const authMedicaCriteria = !major18
  const authAlternancaCriteria = nomesCicles 

  //const [dadesAutoritzacions, setDadesAutoritzacions] = useState({validat: false});

  const handleDadesAutoritzacions = (noError) => {
    let d = {
     "validat": noError,

    /* DADES AUTORITZACIONS */
    "authCompromis": authCompromis,
    "authIntranet": authIntranet,
    "authInternet": authInternet,
    "authRecursosDigitals": authRecursosDigitals,
    "authSortides": authSortides,
    "authMobils": authMobils,
    "authResponsable": authResponsable,
    "authGDPR": authGDPR,
  }
  
  if( authMedicaCriteria ) d.authMedica = authMedica
  if( authAlternancaCriteria ) d.authAlternanca = authAlternanca
  
      //console.log("DADES_AUTORITZACIONS",d)
      //setDadesAutoritzacions(d)
      props.handleDadesAutoritzacions(d)
    }


  /* AUTH COMPROMIS */
  const validaAuthCompromis = () => {
    return authCompromis === "1" ? null : "Aquest camp és obligatori"
  }

 const handleChangeCompromis = (t) => {

      setAuthCompromis(t === "0" ? "1" : "0") 

      handleDadesAutoritzacions(false)
 }


  /* AUTH GDPR */
  const validaAuthGDPR = () => {
    return authGDPR === "1" ? null : "Aquest camp és obligatori"
  }

  const handleChangeGDPR = (t) => {

    setAuthGDPR(t === "0" ? "1" : "0")

    //if(t === "1") handleDadesAutoritzacions(false)
    handleDadesAutoritzacions(false)
  }


  /* AUTH RESPONSABLE */
  const validaAuthResponsable = () => {
    return authResponsable === "1" ? null : "Aquest camp és obligatori"
  }

  const handleChangeResponsable = (t) => {

    setAuthResponsable(t === "0" ? "1" : "0")

    //if(t === "1") handleDadesAutoritzacions(false)
    handleDadesAutoritzacions(false)
  }


  /* AUTH MOBILS */
  const validaAuthMobils = () => {
    return authMobils === "1" ? null : "Aquest camp és obligatori"
  }

  const handleChangeMobils = (t) => {

    setAuthMobils(t === "0" ? "1" : "0")

    handleDadesAutoritzacions(false)
  }


  /* AUTH SORTIDES */
  const validaAuthSortides = () => {
    return authSortides === "1" ? null : "Aquest camp és obligatori"
  }

  const handleChangeSortides = (t) => {

    setAuthSortides(t === "0" ? "1" : "0")

    handleDadesAutoritzacions(false)
  }


  /* AUTH MEDICA */
 const handleChangeMedica= (t) => {

      setAuthMedica(t === "0" ? "1" : "0") 

      handleDadesAutoritzacions(false)
 }


  /* AUTH ALTERNANÇA*/
 const handleChangeAlternanca = (t) => {

      setAuthAlternanca(t === "0" ? "1" : "0") 

     handleDadesAutoritzacions(false)
 }


  /* AUTH DRETS IMATGE */
  const validaAuthIntranet = () => {
    return authIntranet ? null : "Heu d'indicar una resposta"
  }

  const validaAuthRecursosDigitals = () => {
    return authRecursosDigitals ? null : "Heu d'indicar una resposta"
  }

  /*
  const validaAuthDretsImatge = () => {
    //només obligatori pels menors de 14
    //if(props.dadesPersonals.edat >= 14 ) return null
    return authDretsImatge ? null : "Heu d'indicar una resposta"
  }
  */

  const validaAuthInternet = () => {
    return authInternet ? null : "Heu d'indicar una resposta"
  }


  /*
  const handleChangeDretsImatge = (t) => {

    setAuthDretsImatge(t)

    handleDadesAutoritzacions(false)
  }
  */




/* VALIDA AUTORITZACIONS */
const validaAutoritzacions = (e) => {
  if(e) e.preventDefault();

  let error = {}

  error.authIntranet = validaAuthIntranet();
  handleErrors('authIntranet',error)
  
  error.authRecursosDigitals = validaAuthRecursosDigitals();
  handleErrors('authRecursosDigitals',error)
  
  error.authInternet = validaAuthInternet();
  handleErrors('authInternet',error)

  error.authCompromis = validaAuthCompromis();
  handleErrors('authCompromis',error)

  error.authMobils = validaAuthMobils();
  handleErrors('authMobils',error)

  error.authGDPR = validaAuthGDPR();
  handleErrors('authGDPR',error)

  error.authResponsable = validaAuthResponsable();
  handleErrors('authResponsable',error)

  //error.authDretsImatge = validaAuthDretsImatge();
  //handleErrors('authDretsImatge',error)

  if( !major18 ) {
    error.authSortides = validaAuthSortides();
    handleErrors('authSortides',error)
  }

  setErrors(error)

  let noError = true;
  //DEVELOP 
  if(!config.develop) // bypass errors if develop == true
  {
    Object.keys(error).forEach( (k) => { if(error[k] !== null) noError = false } )
  }

  //console.log('ERROR',error);

  handleDadesAutoritzacions(noError)

  if(noError)
  {
     setAuthorizationsOpen(false);
  }

  return noError;
}


return (
  <div className="container authorizations">
    <div className="row">
      <div className="col col-12 ">
        <div className="t-Region t-Region--hideShow is-expanded t-Region--scrollBody t-Form--noPadding margin-top-sm margin-bottom-none margin-left-none margin-right-none a-Collapsible">
          <div className="t-Region-header">
            <div className="t-Region-headerItems  t-Region-headerItems--controls">
              <button
                className="t-Button t-Button--icon t-Button--hideShow"
                type="button"
                onClick={toggleAuthorizationsOpen}
              >
                {authorizationsOpen && (
                  <FontAwesomeIcon
                    icon={faChevronUp}
                    fontSize="18"
                    className="t-Icon"
                  />
                )}
                {!authorizationsOpen && (
                  <FontAwesomeIcon
                    icon={faChevronDown}
                    fontSize="18"
                    className="t-Icon"
                  />
                )}
              </button>
            </div>
            <div className="t-Region-headerItems t-Region-headerItems--title">
              <h2 className="t-Region-title a-Collapsible-heading">
                Protecció de dades
              </h2>
            </div>
            <div className="t-Region-headerItems t-Region-headerItems--buttons"></div>
          </div>
          <div className="t-Region-bodyWrap">
            <Dropdown open={authorizationsOpen}>
              <div className="t-Region-body a-Collapsible-content">
                <div className="container">
                  <div className="row">
                    <div className="col col-12 ">
                      <div className="t-Region t-Region--noPadding t-Region--removeHeader t-Region--noBorder t-Region--scrollBody t-Form--noPadding t-Form--leftLabels margin-top-sm">
                        <div className="t-Region-bodyWrap">
                          <div className="t-Region-body">
                            <div className="container">

                              <AuthCompromis auth={authCompromis} handleChange={handleChangeCompromis} error={errors.AuthCompromis} /> <br/>

                              { major18 ? (
                                <>
                                  <AuthDretsImatgeCompostMajors18

                                    authIntranet={authIntranet}
                                    setAuthIntranet={setAuthIntranet}

                                    authInternet={authInternet}
                                    setAuthInternet={setAuthInternet}

                                    errors={errors} />

                                  <AuthRecursosDigitalsMajors18 auth={authRecursosDigitals} handleChange={setAuthRecursosDigitals} error={errors.authRecursosDigitals} />

                                  <br/>
                                </>)
                                :
                                (<>

                                  <AuthDretsImatgeCompostMenors18

                                    authIntranet={authIntranet}
                                    setAuthIntranet={setAuthIntranet}

                                    authInternet={authInternet}
                                    setAuthInternet={setAuthInternet}

                                    errors={errors} />

                                  <AuthRecursosDigitalsMenors18 auth={authRecursosDigitals} handleChange={setAuthRecursosDigitals} error={errors.authRecursosDigitals} />

                                  <br/>
                                </>)
                              }

                            <AuthMobils auth={authMobils} handleChange={handleChangeMobils} errors={errors.authMobils} /> <br/>


                            { !major18 ? (<>

                              <AuthSortidesMenors auth={authSortides} handleChange={handleChangeSortides} errors={errors.authSortides} /> <br/>

                            </>) : (<>
                            
                            <AuthSortides auth={authSortides} handleChange={handleChangeSortides} errors={errors.authSortides} /> <br/> 
                            
                            </>)

                            }


                              { authAlternancaCriteria && <AuthAlternanca auth={authAlternanca} handleChange={handleChangeAlternanca} errors={errors.authAlternanca} /> }

                              { authMedicaCriteria && <AuthMedica auth={authMedica} handleChange={handleChangeMedica} errors={errors.authMedica} /> }

                              <AuthGDPR auth={authGDPR} handleChange={handleChangeGDPR} errors={errors.authGDPR} />

                              <AuthResponsable auth={authResponsable} handleChange={handleChangeResponsable} error={errors.authResponsable} /> 

                              <AuthEdat17 edat={props.dadesPersonals.edat} /> 

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="container">
                            <div className="row">
                              <div className="col col-12" align="center">
                                <button onClick={validaAutoritzacions} className="button">SEGÜENT</button>
                              </div>
                            </div>
                          </div>

                </div>
              </Dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}